import { BrowserRouter,Routes,Route } from "react-router-dom";

import React from 'react'
import Remote from "../pages/Remote/Remote";
import Dashboard from "../pages/Dashboard/Dashboard";
import Reports from "../pages/Reports/Reports";
import MyComponent from "../pages/ScrollingCheck";

const AppRoutes = () => {
  return (
    <BrowserRouter>
    <Routes>
        <Route path='/remote' element={<Remote/>}/>
        <Route path='/' element={<Dashboard/>}/>
        <Route path='/report' element={<Reports/>}/>
        <Route path='/scrolling' element={<MyComponent/>}/>

    </Routes>
    </BrowserRouter>
  )
}

export default AppRoutes